"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _rem = _interopRequireDefault(require("polished/lib/helpers/rem"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _toColorString = _interopRequireDefault(require("polished/lib/color/toColorString"));

var _designTokens = require("@decisiv/design-tokens");

var _Option = _interopRequireDefault(require("./Option"));

var _utils = require("./utils");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var StyledCategory = _styledComponents.default.li.attrs({
  role: 'option',
  'aria-disabled': true
}).withConfig({
  displayName: "Category__StyledCategory",
  componentId: "sc-1kvf2r-0"
})(["color:", ";font-size:", ";cursor:default;line-height:1.4;text-align:left;padding:", ";"], (0, _toColorString.default)(_designTokens.color.base.alaskanHusky), (0, _rem.default)(_designTokens.typography.size.alias.paragraph2), "".concat((0, _rem.default)(8), " ").concat((0, _rem.default)(30), " ").concat((0, _rem.default)(7), " ").concat((0, _rem.default)(10)));

var Category = function Category(_ref) {
  var borderRadius = _ref.borderRadius,
      label = _ref.label,
      items = _ref.items,
      showCheckbox = _ref.showCheckbox;
  return _react.default.createElement(_react.Fragment, null, _react.default.createElement(StyledCategory, null, label), items.map(function (subItem) {
    var id = (0, _utils.getId)(subItem);
    return _react.default.createElement(_Option.default, _extends({}, subItem, {
      key: id,
      id: id,
      borderRadius: borderRadius,
      showCheckbox: showCheckbox
    }));
  }));
};

var _default = Category;
exports.default = _default;